import { ChangeDetectionStrategy, Component } from "@angular/core";
import { EdLoaderModule } from "@edenred/components/loader";

@Component({
  selector: "er-table-loader",
  standalone: true,
  imports: [EdLoaderModule],
  templateUrl: "./table-loader.component.html",
  styleUrls: ["./table-loader.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TableLoaderComponent {}
